const commonActions = {
    SET_ALERT: 'SET_ALERT',
    SET_BUTTON_LOADER: 'SET_BUTTON_LOADER',
    SET_PAGINATION_CURRENT_PAGE: 'SET_PAGINATION_CURRENT_PAGE',
    SET_SEARCH_TEXT: 'SET_SEARCH_TEXT',
    SHOW_DELETE_CONFIRMATION_MODAL: 'SHOW_DELETE_CONFIRMATION_MODAL',
    SET_LOGOUT_MODAL: 'SET_LOGOUT_MODAL',
};

export default commonActions;